import React from 'react'
import smmimg1 from './images/smm3.png'
import smmimg2 from './images/smm4.png'
export default function SmmProces2() {
  return (
    <>
      <div className="container smmImg-main">
        <div className="row row-cols-2 smmImg-sub-main">
            <div className="col smm-large-Img">
                <img src={smmimg1} alt="" />
            </div>
            <div className="col smm-small-Img">
                <img src={smmimg2} alt="" />
            </div>
        </div>
      </div>
      <div className="smm-process-main">
        <div className="header-process-main">
            <h1>What Is Social Media Marketing?</h1>
        </div>
        <div className="para-process-main">
            <p>
            Social media marketing is a powerful tool that helps businesses connect with their audience across platforms like Facebook, X (formerly Twitter), LinkedIn, Instagram, and Pinterest. It’s more than just posting updates—it’s about strategically building brand awareness, engaging with your audience, and driving meaningful results.
            </p>
            <p>
            Social media marketing allows businesses, from small startups to large enterprises, to engage with their target audience where they spend a significant amount of time online. By leveraging these platforms, you can turn followers into loyal customers and create a community around your brand.
            </p>
            {/* <p>
            At Raj Digital Marketing, we understand that building a strong social media presence requires more than just frequent posts. It demands a strategic approach tailored to your audience, brand voice, and industry. Unfortunately, many businesses enter the social media space without a clear understanding of what works and what doesn’t—wasting valuable time and resources.
That’s where we come in. Our social media specialists help you navigate the differences between B2C and B2B marketing, choose the right platforms for your business, and craft a strategy that connects, engages, and converts.
Learn how to leverage social platforms effectively with a structured plan, expert insights, and a focus on measurable growth. Let Raj Digital Marketing guide you from setup to success in your social media journey.

            </p> */}
        </div>
      </div>
    </ >
  )
}
